/**
 * Normalize emails for API payloads (trim + lowercase).
 * Users may type any case; we always send/store lowercase.
 */
export function normalizeEmail(email) {
  if (email == null) return "";
  return String(email).trim().toLowerCase();
}

/** Normalize when value is non-empty; otherwise return as-is ("" / null). */
export function normalizeEmailOptional(email) {
  if (email == null) return email;
  const trimmed = String(email).trim();
  if (!trimmed) return "";
  return trimmed.toLowerCase();
}
